import { useEffect } from "react";
import { useLocation, useRoute } from "wouter";

/** Saved Job links retain their exact identity inside the existing Contracts/Work workspace. */
export default function EngagementDetail() {
  const [, params] = useRoute("/engagement/:id");
  const [, navigate] = useLocation();
  const id = params?.id;
  useEffect(() => { if (id) navigate(`/contracts?engagement=${encodeURIComponent(id)}`, { replace: true }); }, [id, navigate]);
  return <div className="container-x py-16" role="status">Opening work…</div>;
}
